import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {

  private wsBaseUrl = environment.url.webApi;

  private socket: WebSocket | null = null;

  private botResponse = new Subject<any>();

  botResponse$ = this.botResponse.asObservable();
  private activeChatbot: any = null;

  constructor() { }


  registerChatbot(chatbot: any): void {
    this.activeChatbot = chatbot;
  }

  get chatbot(): any {
    return this.activeChatbot;
  }
  // ============================================================
  // CONNECT
  // ============================================================

  connect(sessionId: string, history_id?: any): void {
    console.log(history_id)
    if (!sessionId) {
      return;
    }

    // Close existing socket before creating a new one
    if (
      this.socket &&
      this.socket.readyState !== WebSocket.CLOSED
    ) {
      this.socket.close();
    }

    // Get threadId from sessionStorage
    const threadId =
      sessionStorage.getItem('threshId') ||
      sessionStorage.getItem('threadId');

    const params = new URLSearchParams();

    if (threadId) {
      params.append('threadId', threadId);
    }

    if (
      history_id !== undefined &&
      history_id !== null &&
      String(history_id).trim() !== ''
    ) {
      params.append('historyId', String(history_id));
    }

    const queryString = params.toString();
    const url = `${this.wsBaseUrl}${sessionId}${queryString ? `?${queryString}` : ''}`;

    this.socket = new WebSocket(url);

    this.socket.onopen = () => {
      console.log('WebSocket connected');
    };

    this.socket.onmessage = (event: MessageEvent) => {

      try {

        const response =
          JSON.parse(event.data);

        this.botResponse.next(response);

      } catch {

        this.botResponse.next(
          event.data
        );

      }
    };

    this.socket.onerror = (error) => {

      console.error(
        'WebSocket Error:',
        error
      );

    };

    this.socket.onclose = () => {

      console.log(
        'WebSocket disconnected'
      );

    };
  }

  // ============================================================
  // SEND MESSAGE
  // ============================================================

  sendMessage(message: any): void {

    if (
      this.socket &&
      this.socket.readyState === WebSocket.OPEN
    ) {

      this.socket.send(
        JSON.stringify(message)
      );

    } else {

      console.warn(
        'Socket not connected.'
      );

    }
  }

  // ============================================================
  // DISCONNECT
  // ============================================================

  disconnect(): void {

    if (!this.socket) {
      return;
    }

    this.socket.onopen = null;
    this.socket.onmessage = null;
    this.socket.onerror = null;
    this.socket.onclose = null;

    if (
      this.socket.readyState === WebSocket.OPEN ||
      this.socket.readyState === WebSocket.CONNECTING
    ) {
      this.socket.close();
    }

    this.socket = null;
  }

}